import React, { forwardRef } from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

const cn = (...inputs) => twMerge(clsx(inputs));

// A span, not a <button>: buttons are atomic boxes, so in a truncated line an overflowing
// chip disappears whole and leaves a gap. An inline span lets the ellipsis cut mid-chip.
const InlineEditChip = forwardRef(({ children, ariaLabel, className, onClick, onKeyDown, ...rest }, ref) => (
  <span
    ref={ref}
    role="button"
    tabIndex={0}
    aria-label={ariaLabel}
    onClick={onClick}
    onKeyDown={(event) => {
      onKeyDown?.(event);
      if (!event.defaultPrevented && onClick && (event.key === "Enter" || event.key === " ")) {
        event.preventDefault();
        onClick(event);
      }
    }}
    {...rest}
    className={cn(
      "mx-0.5 cursor-pointer rounded-md hover:bg-gray-200 px-0.5 text-gray-900 underline decoration-dotted decoration-gray-400 underline-offset-4 transition-colors outline-none focus-visible:ring-2 focus-visible:ring-secondary/40 dark:bg-gray-800 dark:text-gray-100",
      className,
    )}
  >
    {children}
  </span>
));

InlineEditChip.displayName = "InlineEditChip";

export default InlineEditChip;
